import { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Popover,
  Button,
  MenuItem,
  Divider,
} from "@mui/material";
import { DateCalendar, PickersDay } from "@mui/x-date-pickers";

import { IconCalendar, IconChevronDown } from "@tabler/icons-react";
import moment from "moment";
import { toast } from "react-toastify";
import { useMediaQuery, useTheme } from "@mui/material";

const DateRanger = ({
  start_date,
  end_date,
  setstart_date,
  setend_date,
}: any) => {
  const [anchorEl, setanchorEl] = useState(null);
  const [start_dateInput, setstart_dateInput] = useState<any>(moment());
  const [end_dateInput, setend_dateInput] = useState<any>(moment());

  useEffect(() => {
    setstart_dateInput(moment(start_date));
    setend_dateInput(moment(end_date));
  }, [start_date, end_date]);

  const handleClick = (event: any) => {
    setanchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setstart_dateInput(moment(start_date));
    setend_dateInput(moment(end_date));
    setanchorEl(null);
  };

  const ServerDay = (props: any) => {
    const {
      end_dateInput,
      start_dateInput,
      day,
      outsideCurrentMonth,
      ...other
    } = props;

    const isInRange =
      start_dateInput &&
      end_dateInput &&
      day.isBetween(start_dateInput, end_dateInput, "day", "[]");

    const isSelected = !props.outsideCurrentMonth && isInRange;
    return (
      <PickersDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        sx={{ backgroundColor: isSelected ? "#377df61f" : undefined }}
      />
    );
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Stack>
      <Button
        variant="outlined"
        size={isMobile ? "small" : "medium"}
        sx={[
          {
            color: "secondary.dark",
            borderColor: "#fff",
            minWidth: 0,
            px: { xs: 1, sm: 2 },
          },
          (theme) => ({
            ...theme.applyStyles("dark", {
              backgroundColor: "tertiary.main",
              borderColor: "tertiary.light",
              color: "#fff",
            }),
          }),
        ]}
        startIcon={!isMobile ? <IconCalendar size={20} /> : null}
        endIcon={<IconChevronDown size={isMobile ? 16 : 20} />}
        onClick={handleClick}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
          gap={"2px"}
        >
          <Stack>
            <Typography fontWeight={600} fontSize={{ xs: "10px", sm: "12px" }}>
              {moment(start_date).format("DD/MM/YYYY")}
            </Typography>
          </Stack>
          -
          <Stack>
            <Typography fontWeight={600} fontSize={{ xs: "10px", sm: "12px" }}>
              {moment(end_date).format("DD/MM/YYYY")}
            </Typography>
          </Stack>
        </Stack>
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            width: { xs: "100vw", sm: "auto" },
            maxWidth: { xs: "100vw", sm: "unset" },
            borderRadius: 0,
            px: { xs: 2, sm: 0 },
          },
        }}
      >
        <Stack
          sx={{
            display: { xs: "none", sm: "flex" },
            flexDirection: "row",
          }}
        >
          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              borderRight: "1px solid ",
              borderColor: "#f2f2f2",
            }}
            gap={0.2}
          >
            <MenuItem
              sx={styles.menuItem}
              onClick={() => {
                setstart_dateInput(moment());
                setend_dateInput(moment());
              }}
            >
              Hoje
            </MenuItem>
            <MenuItem
              onClick={() => {
                setstart_dateInput(moment().subtract(1, "days"));
                setend_dateInput(moment().subtract(1, "days"));
              }}
              sx={styles.menuItem}
            >
              Ontem
            </MenuItem>
            <MenuItem
              onClick={() => {
                setstart_dateInput(moment().startOf("week"));
                setend_dateInput(moment().endOf("week"));
              }}
              sx={styles.menuItem}
            >
              Esta semana
            </MenuItem>
            <MenuItem
              onClick={() => {
                setstart_dateInput(
                  moment().subtract(1, "week").startOf("week")
                );
                setend_dateInput(moment().subtract(1, "week").endOf("week"));
              }}
              sx={styles.menuItem}
            >
              Último semana
            </MenuItem>{" "}
            <MenuItem
              onClick={() => {
                setstart_dateInput(moment().startOf("month"));
                setend_dateInput(moment().endOf("month"));
              }}
              sx={styles.menuItem}
            >
              Este mês
            </MenuItem>
            <MenuItem
              onClick={() => {
                setstart_dateInput(
                  moment().subtract(1, "month").startOf("month")
                );
                setend_dateInput(moment().subtract(1, "month").endOf("month"));
              }}
              sx={styles.menuItem}
            >
              Último mês
            </MenuItem>
            <MenuItem
              onClick={() => {
                setstart_dateInput(moment().startOf("year"));
                setend_dateInput(moment().endOf("year"));
              }}
              sx={styles.menuItem}
            >
              Este ano
            </MenuItem>
            <MenuItem
              onClick={() => {
                setstart_dateInput(
                  moment().subtract(1, "year").startOf("year")
                );
                setend_dateInput(moment().subtract(1, "year").endOf("year"));
              }}
              sx={styles.menuItem}
            >
              Último ano
            </MenuItem>
          </Stack>
          <Stack>
            <Stack sx={{ display: "flex", flexDirection: "row" }}>
              <DateCalendar
                maxDate={moment().add(3, "years") || undefined}
                sx={styles.calendar}
                value={moment(start_dateInput)}
                onChange={(e) => {
                  setstart_dateInput(moment(e).format("YYYY-MM-DD"));
                }}
                slots={{
                  day: ServerDay,
                }}
                slotProps={{
                  day: {
                    start_dateInput,
                    end_dateInput,
                  } as any,
                }}
              />

              <DateCalendar
                maxDate={moment().add(3, "years") || undefined}
                sx={styles.calendar}
                value={moment(end_dateInput)}
                minDate={moment(start_dateInput)}
                onChange={(e) => {
                  setend_dateInput(moment(e).format("YYYY-MM-DD"));
                }}
                slots={{
                  day: ServerDay,
                }}
                slotProps={{
                  day: {
                    start_dateInput,
                    end_dateInput,
                  } as any,
                }}
              />
            </Stack>
            <Stack
              pr={2}
              pb={2}
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              gap={2}
            >
              <Button
                fullWidth={false}
                onClick={() => {
                  setstart_dateInput(start_date);
                  setend_dateInput(end_date);
                  handleClose();
                }}
              >
                Cancelar
              </Button>
              <Button
                fullWidth={false}
                variant="contained"
                onClick={() => {
                  if (start_dateInput > end_dateInput) {
                    toast.info("Selecione um período válido");
                    return;
                  }

                  setstart_date(start_dateInput);
                  setend_date(end_dateInput);
                  handleClose();
                }}
              >
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          sx={{
            display: { xs: "flex", sm: "none" },
            flexDirection: "column",
            padding: 1,
            paddingY: 0,
          }}
        >
          <Stack>
            <Stack sx={{ display: "flex", flexDirection: "column" }}>
              <DateCalendar
                maxDate={moment().add(3, "years") || undefined}
                sx={styles.calendar}
                value={moment(start_dateInput)}
                onChange={(e) => {
                  setstart_dateInput(moment(e).format("YYYY-MM-DD"));
                }}
                slots={{
                  day: ServerDay,
                }}
                slotProps={{
                  day: {
                    start_dateInput,
                    end_dateInput,
                  } as any,
                }}
              />

              <DateCalendar
                maxDate={moment().add(3, "years") || undefined}
                sx={styles.calendar}
                value={moment(end_dateInput)}
                minDate={moment(start_dateInput)}
                onChange={(e) => {
                  setend_dateInput(moment(e).format("YYYY-MM-DD"));
                }}
                slots={{
                  day: ServerDay,
                }}
                slotProps={{
                  day: {
                    start_dateInput,
                    end_dateInput,
                  } as any,
                }}
              />
            </Stack>
            <Divider />
            <Stack
              gap={0.5}
              sx={{
                display: "flex",
                flexDirection: "row",
                overflowY: "scroll",
                scrollbarWidth: "none",
              }}
            >
              <MenuItem
                sx={styles.menuItem}
                onClick={() => {
                  setstart_dateInput(moment());
                  setend_dateInput(moment());
                }}
              >
                Hoje
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setstart_dateInput(moment().subtract(1, "days"));
                  setend_dateInput(moment().subtract(1, "days"));
                }}
                sx={styles.menuItem}
              >
                Ontem
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setstart_dateInput(moment().startOf("week"));
                  setend_dateInput(moment().endOf("week"));
                }}
                sx={styles.menuItem}
              >
                Esta semana
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setstart_dateInput(
                    moment().subtract(1, "week").startOf("week")
                  );
                  setend_dateInput(moment().subtract(1, "week").endOf("week"));
                }}
                sx={styles.menuItem}
              >
                Último semana
              </MenuItem>{" "}
              <MenuItem
                onClick={() => {
                  setstart_dateInput(moment().startOf("month"));
                  setend_dateInput(moment().endOf("month"));
                }}
                sx={styles.menuItem}
              >
                Este mês
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setstart_dateInput(
                    moment().subtract(1, "month").startOf("month")
                  );
                  setend_dateInput(
                    moment().subtract(1, "month").endOf("month")
                  );
                }}
                sx={styles.menuItem}
              >
                Último mês
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setstart_dateInput(moment().startOf("year"));
                  setend_dateInput(moment().endOf("year"));
                }}
                sx={styles.menuItem}
              >
                Este ano
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setstart_dateInput(
                    moment().subtract(1, "year").startOf("year")
                  );
                  setend_dateInput(moment().subtract(1, "year").endOf("year"));
                }}
                sx={styles.menuItem}
              >
                Último ano
              </MenuItem>
            </Stack>
            <Divider />
            <Stack
              mt={2}
              pr={2}
              pb={2}
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              gap={2}
            >
              <Button
                fullWidth={false}
                onClick={() => {
                  setstart_dateInput(start_date);
                  setend_dateInput(end_date);
                  handleClose();
                }}
              >
                Cancelar
              </Button>
              <Button
                fullWidth={false}
                variant="contained"
                onClick={() => {
                  if (start_dateInput > end_dateInput) {
                    toast.info("Selecione um período válido");
                    return;
                  }
                  setstart_date(start_dateInput);
                  setend_date(end_dateInput);
                  handleClose();
                }}
              >
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Popover>
    </Stack>
  );
};

const styles = {
  calendar: {
    "& .MuiPickersYear-yearButton.Mui-selected ": {
      color: "#FFFFFF",
    },
    "& .MuiPickersMonth-monthButton.Mui-selected ": {
      color: "#FFFFFF",
    },
    "& .MuiPickersDay-root.Mui-selected": {
      color: "#FFFFFF",
    },
    height: { xs: "280px", sm: "324px" },
  },
  menuItem: {
    color: "primary.main",
    fontWeight: 700,
    fontSize: "12px",
    whiteSpace: "nowrap",
    width: "auto",
  },
};

export default DateRanger;
